import { render, staticRenderFns } from "./LoadingSpinnerOverlay.vue?vue&type=template&id=48f80eb4"
import script from "./LoadingSpinnerOverlay.vue?vue&type=script&lang=js"
export * from "./LoadingSpinnerOverlay.vue?vue&type=script&lang=js"
import style0 from "./LoadingSpinnerOverlay.vue?vue&type=style&index=0&id=48f80eb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports